import CopyrightFooter from "./CopyrightFooter";
import {Link} from "react-router-dom";
import ScrollToTop from "../../common/ScrollTop";
import React from "react";
import ContactModal from "../../ContactModal";
import FooterContent4 from "../FooterContent4";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

const index = ({ footerStyle = "" }) => {
  return (
    <footer className={`main-footer ${footerStyle}`}>
      <div className="auto-container">
        <div className="widgets-section" data-aos="fade-up">
          <div className="row">
            <div className="big-column col-xl-4 col-lg-3 col-md-12">
              <div className="footer-column about-widget">
                <Link to="/" className="logo" aria-label="Lien vers l'accueil">
                  <LazyLoadImage
                      width="200px"
                      height="auto"
                      src="/images/Logo-THF-web.svg"
                      alt="brand"
                      effect="blur"
                  />
                </Link>
                <p className="address">
                  Talents Handicap Formation est un service Groupe <b>Talents Handicap</b><br/>
                  qui organise également les forums en ligne de l’emploi Talents Handicap.
                </p>
                <p className="question">
                  Vous avez une question ou une demande ?
                </p>
                <p className="address"></p>
                <div className="btn-box" style={{marginTop: "10px"}}>
                  <ContactModal textButton="Contactez-nous" showText={false} small="small" linkPageContact={true}/>
                </div>
              </div>
            </div>

            <div className="big-column col-xl-8 col-lg-9 col-md-12">
              <div className="row">
                <FooterContent4 />
              </div>
            </div>

          </div>
        </div>
      </div>

      <CopyrightFooter />
      <ScrollToTop />

    </footer>
  );
};

export default index;
